import { Box } from '@gemini/core';
import TopBar from '@mfe-presentation/components/TopBar';
import {
    progressHeightDesktop,
    progressHeightTablet,
    topbarHeight,
} from '@mfe-presentation/constants/layout';
import AppRouter from '@mfe-presentation/routes/AppRouter';
import { TLogo } from '@mfe-types/logo';

const footerHeightDesktop = 88;
const footerHeightTablet = 72;
const navigationHeight = 56;
const blurEffectHeight = 16;

const AppLayout = ({ logo }: { logo: TLogo }) => {
    return (
        <Box minWidth="300px">
            <TopBar logo={logo} />
            <Box
                testId="app-router-container"
                display="flex"
                flexDirection="column"
                alignItems="center"
                backgroundColor="color.background.default"
                paddingTop="0"
                paddingHorizontal="spacing.16"
                paddingBottom={{
                    'breakpoint.base': `${
                        footerHeightTablet + navigationHeight + blurEffectHeight
                    }px`,
                    'breakpoint.md': `${
                        footerHeightDesktop + navigationHeight + blurEffectHeight
                    }px`,
                }}
                maxWidth="780px"
                marginBottom="sizing.48"
                marginTop={{
                    'breakpoint.base': `${topbarHeight + progressHeightTablet}px`,
                    'breakpoint.md': `${topbarHeight + progressHeightDesktop}px`,
                }}
                marginHorizontal="auto"
            >
                <AppRouter />
            </Box>
        </Box>
    );
};

export default AppLayout;
